import { render, staticRenderFns } from "./Page3Chart2.vue?vue&type=template&id=188c9b20&scoped=true&"
import script from "./Page3Chart2.vue?vue&type=script&lang=ts&"
export * from "./Page3Chart2.vue?vue&type=script&lang=ts&"
import style0 from "./Page3Chart2.vue?vue&type=style&index=0&id=188c9b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188c9b20",
  null
  
)

export default component.exports